// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Kwl0","col":"styles_col__1vmKJ"};